import { baseApi } from "./baseApi";

// backend may return wrapped envelope; normalize to raw data for components
type ApiEnvelope<T> = { success?: boolean; data?: T; timestamp?: string };

function unwrapInviteResponse<T>(payload: ApiEnvelope<T> | T): T {
  if (payload != null && typeof payload === "object" && "data" in payload && "success" in payload) {
    return (payload as ApiEnvelope<T>).data as T;
  }
  return payload as T;
}

export type InviteStatus = "active" | "used" | "expired" | "revoked";

export interface InviteCode {
  _id: string;
  code: string;
  status: InviteStatus;
  expiresAt: string | null;
  createdAt: string;
  usedAt?: string;
  usedBy?: string;
  metadata?: {
    note?: string;
  };
}

export interface MyInvitesResponse {
  invites: InviteCode[];
  remainingQuota: number;
}

export interface GenerateInviteRequest {
  note?: string;
}

export interface GenerateInviteResponse {
  code: string;
  expiresAt: string | null;
  remainingQuota: number;
}

export const invitesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyInvites: builder.query<MyInvitesResponse, void>({
      query: () => "/invites/my-invites",
      transformResponse: (response: ApiEnvelope<MyInvitesResponse> | MyInvitesResponse): MyInvitesResponse =>
        unwrapInviteResponse(response),
      providesTags: ["Invites"],
    }),
    generateInvite: builder.mutation<GenerateInviteResponse, GenerateInviteRequest | void>({
      query: (body) => ({
        url: "/invites/generate",
        method: "POST",
        body: body || {},
      }),
      transformResponse: (response: ApiEnvelope<GenerateInviteResponse> | GenerateInviteResponse): GenerateInviteResponse =>
        unwrapInviteResponse(response),
      invalidatesTags: ["Invites"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetMyInvitesQuery, useGenerateInviteMutation } = invitesApi;
